// extracted by mini-css-extract-plugin
export default {"grid_city":"Page2_grid_city__Em-TX","box":"Page2_box__I+4TC","box3":"Page2_box3__+l7ae"};